/* eslint-disable @typescript-eslint/default-param-last */
import {
  DELETE_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION,
  SET_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION,
  DELETE_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION,
  DELETE_SINGLE_WHITEBOARD_COLLOBARATOR,
  SET_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION,
  SET_SINGLE_WHITEBOARD_COLLOBARATOR,
  SET_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION,
  DELETE_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION,
  SET_SUBJECTIVE_CURSOR,
  CLEAR_SUBJECTIVE_CURSORS,
} from "@/constants/ActionTypes";
import initialState from "@/store/initialState";
import {
  ISetSingleCodeChunkForUserForAQuestion,
  TCollabTemporaryDataAction,
  ISetSingleSubjectiveChunkAction,
  ISetSubjectiveCursorAction,
  IClearSubjectiveCursorsAction,
} from "@/types/collabTemporaryData.types";

const collabTemporaryDataReducer = (
  state = initialState.collabTemporaryData,
  action: ISetSingleCodeChunkForUserForAQuestion | TCollabTemporaryDataAction,
) => {
  switch (action.type) {
    case SET_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION: {
      if ("language" in action.payload) {
        const {
          chunkData,
          questionSlug,
          userEmail,
          codeModifiedAt,
          languageModifiedAt,
          id,
          language,
        } = action.payload;
        const currentQuestionCodeChunks = {
          ...state.codeSyncData[questionSlug],
        };
        if (
          !currentQuestionCodeChunks[userEmail] ||
          currentQuestionCodeChunks[userEmail].id !== id
        ) {
          currentQuestionCodeChunks[userEmail] = {
            codeModifiedAt,
            id,
            languageModifiedAt,
            questionSlug,
            userEmail,
            codeChunkData: {},
            isCompleted: false,
            language,
          };
        }
        currentQuestionCodeChunks[userEmail].codeChunkData[
          chunkData.currentChunkNumber
        ] = chunkData;
        currentQuestionCodeChunks[userEmail].isCompleted =
          chunkData.currentChunkNumber === chunkData.totalNumberOfChunks &&
          chunkData.totalNumberOfChunks ===
            Object.keys(currentQuestionCodeChunks[userEmail].codeChunkData)
              .length;
        return {
          ...state,
          codeSyncData: {
            ...state.codeSyncData,
            [questionSlug]: currentQuestionCodeChunks,
          },
        };
      }
      return state;
    }
    case DELETE_SINGLE_CODE_CHUNK_FOR_USER_FOR_QUESTION: {
      if ("userEmail" in action.payload) {
        const { questionSlug, userEmail } = action.payload;
        const currentQuestionCodeChunks = {
          ...state.codeSyncData[questionSlug],
        };
        if (currentQuestionCodeChunks[userEmail])
          delete currentQuestionCodeChunks[userEmail];
        return {
          ...state,
          codeSyncData: {
            ...state.codeSyncData,
            [questionSlug]: currentQuestionCodeChunks,
          },
        };
      }
      return state;
    }
    case SET_SINGLE_WHITEBOARD_COLLOBARATOR: {
      if ("user" in action.payload) {
        const currentCollobarators = new Map(
          state.whiteboardCollobarators[action.payload.questionSlug],
        );
        const collobarator =
          currentCollobarators.get(action.payload.user.email) ?? {};
        collobarator.pointer = action.payload.pointer;
        collobarator.button = action.payload.button;
        collobarator.selectedElementIds = action.payload.selectedElementIds;
        collobarator.username = action.payload.user.name;
        collobarator.color = {
          background: action.payload.user.color,
          stroke: action.payload.user.color,
        };
        currentCollobarators.set(action.payload.user.email, collobarator);
        return {
          ...state,
          whiteboardCollobarators: {
            ...state.whiteboardCollobarators,
            [action.payload.questionSlug]: currentCollobarators,
          },
        };
      }
      return state;
    }
    case DELETE_SINGLE_WHITEBOARD_COLLOBARATOR: {
      if ("email" in action.payload) {
        const currentCollobarators = new Map(
          state.whiteboardCollobarators[action.payload.questionSlug],
        );
        currentCollobarators.delete(action.payload.email);
        return {
          ...state,
          whiteboardCollobarators: {
            ...state.whiteboardCollobarators,
            [action.payload.questionSlug]: currentCollobarators,
          },
        };
      }
      return state;
    }
    case SET_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION: {
      if ("chunkDrawingData" in action.payload) {
        const { chunkDrawingData, id, modifiedAt, questionSlug, userEmail } =
          action.payload;
        const currentQuestionDrawingChunks = {
          ...state.drawingSyncData[questionSlug],
        };
        if (
          !currentQuestionDrawingChunks[userEmail] ||
          currentQuestionDrawingChunks[userEmail].id !== id
        ) {
          currentQuestionDrawingChunks[userEmail] = {
            modifiedAt,
            id,
            questionSlug,
            userEmail,
            drawingChunkData: {},
            isCompleted: false,
          };
        }
        currentQuestionDrawingChunks[userEmail].drawingChunkData[
          chunkDrawingData.currentChunkNumber
        ] = chunkDrawingData;
        currentQuestionDrawingChunks[userEmail].isCompleted =
          chunkDrawingData.currentChunkNumber ===
            chunkDrawingData.totalNumberOfChunks &&
          chunkDrawingData.totalNumberOfChunks ===
            Object.keys(
              currentQuestionDrawingChunks[userEmail].drawingChunkData,
            ).length;
        return {
          ...state,
          drawingSyncData: {
            ...state.drawingSyncData,
            [questionSlug]: currentQuestionDrawingChunks,
          },
        };
      }
      return state;
    }
    case DELETE_SINGLE_DRAWING_CHUNK_FOR_USER_FOR_QUESTION: {
      if ("userEmail" in action.payload) {
        const { questionSlug, userEmail } = action.payload;
        const currentQuestionDrawingChunks = {
          ...state.drawingSyncData[questionSlug],
        };
        if (currentQuestionDrawingChunks[userEmail])
          delete currentQuestionDrawingChunks[userEmail];
        return {
          ...state,
          drawingSyncData: {
            ...state.drawingSyncData,
            [questionSlug]: currentQuestionDrawingChunks,
          },
        };
      }
      return state;
    }
    case SET_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION: {
      const { chunkContentData, id, modifiedAt, questionSlug, userEmail } = (
        action as ISetSingleSubjectiveChunkAction
      ).payload;
      const currentQuestionChunks = {
        ...state.subjectiveSyncData[questionSlug],
      };
      if (
        !currentQuestionChunks[userEmail] ||
        currentQuestionChunks[userEmail].id !== id
      ) {
        currentQuestionChunks[userEmail] = {
          modifiedAt,
          id,
          questionSlug,
          userEmail,
          contentChunkData: {},
          isCompleted: false,
        };
      }
      currentQuestionChunks[userEmail].contentChunkData[
        chunkContentData.currentChunkNumber
      ] = chunkContentData;
      currentQuestionChunks[userEmail].isCompleted =
        chunkContentData.currentChunkNumber ===
          chunkContentData.totalNumberOfChunks &&
        chunkContentData.totalNumberOfChunks ===
          Object.keys(currentQuestionChunks[userEmail].contentChunkData).length;
      return {
        ...state,
        subjectiveSyncData: {
          ...state.subjectiveSyncData,
          [questionSlug]: currentQuestionChunks,
        },
      };
    }
    case DELETE_SINGLE_SUBJECTIVE_CHUNK_FOR_USER_FOR_QUESTION: {
      const { questionSlug, userEmail } = (
        action as ISetSingleSubjectiveChunkAction
      ).payload;
      const currentQuestionChunks = {
        ...state.subjectiveSyncData[questionSlug],
      };
      if (currentQuestionChunks[userEmail])
        delete currentQuestionChunks[userEmail];
      return {
        ...state,
        subjectiveSyncData: {
          ...state.subjectiveSyncData,
          [questionSlug]: currentQuestionChunks,
        },
      };
    }
    case SET_SUBJECTIVE_CURSOR: {
      const { questionSlug, email, index, length, color, name } = (
        action as ISetSubjectiveCursorAction
      ).payload;
      return {
        ...state,
        subjectiveCursors: {
          ...state.subjectiveCursors,
          [questionSlug]: {
            ...state.subjectiveCursors[questionSlug],
            [email]: { index, length, color, name },
          },
        },
      };
    }
    case CLEAR_SUBJECTIVE_CURSORS: {
      const { questionSlug } = (action as IClearSubjectiveCursorsAction)
        .payload;
      const updatedCursors = { ...state.subjectiveCursors };
      delete updatedCursors[questionSlug];
      return { ...state, subjectiveCursors: updatedCursors };
    }
    default:
      return state;
  }
};

export default collabTemporaryDataReducer;
